import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `StatusLabel` / `StatusColorPicker` (spec M0-F7 §6.4).
 *
 * Vibe has no status chip: monday's is a solid fill in one of the 40 palette colours with the
 * label always rendered on top (U8 — colour is never the only signal). An empty status samples
 * `#c4c4c4` in the reference, which is the palette's `explosive`.
 */
import { STATUS_COLORS } from '@elizmonday/shared';
import { useRef } from 'react';
import { EMPTY_STATUS_COLOR, readableTextOn, statusColor, statusColorHex, statusPalette, } from '../tokens/status-palette.js';
export function StatusLabel({ color, label, size = 'cell', hollow = false, className, title, 'data-testid': dataTestId, }) {
    const name = color ?? EMPTY_STATUS_COLOR;
    const background = statusColor(name);
    const hex = statusColorHex(name);
    const text = label ?? '';
    return (_jsx("span", { className: ['ez-status-label', `ez-status-label--${size}`, className].filter(Boolean).join(' '), "data-testid": dataTestId, "data-status-color": name, title: title ?? text, style: hollow
            ? { color: background, borderColor: background, background: 'transparent' }
            : { background, color: readableTextOn(hex) }, children: text }));
}
/** A 40-swatch grid returning the **API enum name**, never a hex and never a Vibe variable. */
export function StatusColorPicker({ value, onChange, columns = 8, 'data-testid': dataTestId, }) {
    const gridRef = useRef(null);
    function onKeyDown(event) {
        const step = event.key === 'ArrowRight'
            ? 1
            : event.key === 'ArrowLeft'
                ? -1
                : event.key === 'ArrowDown'
                    ? columns
                    : event.key === 'ArrowUp'
                        ? -columns
                        : 0;
        if (step === 0)
            return;
        event.preventDefault();
        const buttons = Array.from(gridRef.current?.querySelectorAll('button') ?? []);
        const active = buttons.indexOf(document.activeElement);
        const next = buttons[Math.min(Math.max(active + step, 0), buttons.length - 1)];
        next?.focus();
    }
    return (_jsx("div", { ref: gridRef, role: "radiogroup", "aria-label": "Status colour", className: "ez-status-picker", "data-testid": dataTestId, onKeyDown: onKeyDown, style: { gridTemplateColumns: `repeat(${columns}, 1fr)` }, children: STATUS_COLORS.map((name) => (_jsx("button", { type: "button", role: "radio", "aria-checked": value === name, "aria-label": name, title: name, tabIndex: value === name || (!value && name === STATUS_COLORS[0]) ? 0 : -1, "data-testid": `status-swatch-${name}`, className: "ez-status-picker__swatch", style: { background: statusColor(name) }, onClick: () => onChange(name) }, name))) }));
}
/** Exported for the `/__ui` gallery and the VF3 fixture. */
export const statusColorNames = Object.keys(statusPalette);
//# sourceMappingURL=StatusLabel.js.map